import React from 'react';
// import { useSelector } from 'react-redux';
// import { useNavigate, useParams } from 'react-router-dom';
import SharedProgrammeOnboardingWizard from './shared_programme_onboarding_wizard';
// import { currentProgrammeEnrollmentSelector } from '../../reducers/programmes_reducer';
// import { sharedProgrammeDurationDays } from '../../services/programmes';
// import { calendarDayFromJSDate } from '../../services/dates';
// import EndUserSharedProgrammeRestartScreen from './end_user_shared_programme_restart_screen';

const EndUserSharedProgrammeOnboardingView = () => {
  // const { sharedProgrammeId: targetSharedProgrammeID } = useParams();

  // const navigate = useNavigate();

  // const today = calendarDayFromJSDate(new Date());

  // const currentProgrammeEnrollment = useSelector(
  //   currentProgrammeEnrollmentSelector,
  // );

  // const currentlyEnrolledSharedProgramme = useSelector(
  //   (state) =>
  //     currentProgrammeEnrollment &&
  //     state.sharedProgrammes.find(
  //       (spr) => spr.id === currentProgrammeEnrollment.sharedProgrammeID,
  //     ),
  // );

  // const isCompleted = isProgrammeEnrollmentCompleted(
  //   currentProgrammeEnrollment,
  //   sharedProgrammeDurationDays(currentlyEnrolledSharedProgramme),
  //   today,
  // );

  // const onRestartCurrentProgramme = () => {

  // };

  // const onBack = () => {
  //   navigate(-1);
  // };

  // if (
  //   isCompleted &&
  //   currentlyEnrolledSharedProgramme?.id === targetSharedProgrammeID
  // ) {
  //   return (
  //     <EndUserSharedProgrammeRestartScreen
  //       sharedProgrammeTitle={currentlyEnrolledSharedProgramme.title}
  //       onNext={onRestartCurrentProgramme}
  //       onBack={onBack}
  //     />
  //   );
  // }

  return <SharedProgrammeOnboardingWizard />;
};

export default EndUserSharedProgrammeOnboardingView;
